import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../../lib/supabase'

export interface AdminListItem {
  id: string
  name: string
}

async function fetchAdminList(): Promise<AdminListItem[]> {
  const { data, error } = await supabase
    .from('admin_accounts')
    .select('id, name')
    .order('name', { ascending: true })

  if (error) throw error
  return data
}

export function useAdminList() {
  return useQuery({
    queryKey: ['admin-list'],
    queryFn: fetchAdminList,
    staleTime: 5 * 60 * 1000,
  })
}